module.exports = __webpack_public_path__ + "img/assistant.55ea0c6f.png";